import React from "react";
import styled from "styled-components";

const EmptyStateWrapper = styled.div<{ size?: "sm" | "md" | "lg" }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  padding: ${({ size }) =>
    size === "sm" ? "1rem" : size === "lg" ? "3rem" : "2rem"};
  text-align: center;
  background-color: #fff;
  color: #6b7280;
  width: 100%;
`;

const Title = styled.p`
  font-size: 1.125rem;
  font-weight: 500;
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
`;

const Subtitle = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
`;

const Icon = styled.div`
  svg {
    width: 40px;
    height: 40px;
    stroke: #002347; /* custom blue color */
    fill: none;
  }
`;

type Props = {
  size?: "sm" | "md" | "lg";
  title: string;
  description: string;
};

export const QuotationEmptyState: React.FC<Props> = ({ size = "md", title, description }) => {
  return (
    <EmptyStateWrapper size={size}>
      <Icon>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 2.25h6m-7.5 3A2.25 2.25 0 015.25 7.5v12A2.25 2.25 0 007.5 21.75h9a2.25 2.25 0 002.25-2.25v-12a2.25 2.25 0 00-2.25-2.25h-1.5m-6 0h6m-3 6v6m-3-3h6"
          />
        </svg>
      </Icon>
      <Title>{title}</Title>
      <Subtitle>{description}</Subtitle>
    </EmptyStateWrapper>
  );
};
